<div *ngIf="message" [class]="calloutClasses">{{ message }}</div>
<rav-table
  [config]="tableConfig"
  [dataSource]="dataSource"
  headerText="Users"
  (actionTriggered)="onActionsTriggered($event)"
></rav-table>
<rav-create-user [accountId]="accountID" [userRoleGroup]="[UserRoleGroup.Main]"> </rav-create-user>
